/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Select_All_EventsInputs */



/**
* | output |
* | --- |
* | "Select All Events" |
*
* @param {Shortcut_Keys_Name_Select_All_EventsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_select_all_events = /** @type {((inputs?: Shortcut_Keys_Name_Select_All_EventsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Select_All_EventsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Selectionner tous les evenements")
	if (locale === "de") return /** @type {LocalizedString} */ ("Alle Ereignisse auswählen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona tutti gli eventi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выбрать все события")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccionar todos los eventos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择所有活动")
	if (locale === "ja") return /** @type {LocalizedString} */ ("すべてのイベントを選択")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सभी इवेंट चुनें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecionar todos os eventos")
	return /** @type {LocalizedString} */ ("Select All Events")
});